import "@measured/puck/puck.css";

import { Render, Data } from "@measured/puck";

import { Loading } from "src/components/utils/Loading";
import config from "./config";

type PuckRendererProps = {
    data: Data | Record<string, unknown> | undefined;
    isLoading?: boolean;
};

export const PuckRenderer = (props: PuckRendererProps) => {
    const { data, isLoading } = props;
    if (isLoading) {
        return <Loading />;
    }

    if (!data) {
        return <></>;
    }

    const normalizedData = ensurePuckDataFormat(data);
    return <Render config={config} data={normalizedData} />;
};

const ensurePuckDataFormat = (data: unknown): Record<string, unknown> => {
    try {
        if (data && typeof data === "object" && "content" in data && "root" in data && Array.isArray(data.content)) {
            return data;
        }

        if (data && typeof data === "object") {
            const dataObj = data as Record<string, unknown>;

            return {
                content: Array.isArray(dataObj.content) ? dataObj.content : [],
                root: (dataObj.root && typeof dataObj.root === "object" ? dataObj.root : { props: {} }) as Data["root"],
            };
        }

        return {
            content: [],
            root: { props: {} },
        };
    } catch (error) {
        console.error("Error normalizing Puck data:", error);
        return {
            content: [],
            root: { props: {} },
        };
    }
};
